import React from 'react';
import PropTypes from 'prop-types';

import HorseDefinition from '../../../shared/HorseDefinition';

const Sire = ({
    sireHorseName,
    sireUid,
    sireCountryOriginCode,
    sireAvgFlatWinDist,
}) => (
    <HorseDefinition
        avgFlatWinDist={sireAvgFlatWinDist}
        countryOriginCode={sireCountryOriginCode}
        horseName={sireHorseName}
        horseUid={sireUid}
        term="Sire"
    />
);

Sire.propTypes = {
    sireHorseName: PropTypes.string,
    sireUid: PropTypes.number,
    sireCountryOriginCode: PropTypes.string,
    sireAvgFlatWinDist: PropTypes.number,
};

export default Sire;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Sire.jsx